import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { SelectItem, TmdxSelect, TmdxTextarea } from '@ds';
import { FormRow } from '@features/components/CaseFormBlocks/components';
import { WOLSType } from '@/api/apis/case';
import { CaseDonorFormType, MAX_WOLS_COMMENT_LENGTH } from '../EditCaseDonor/config';

export const WolsSelector = () => {
  const { control } = useFormContext<CaseDonorFormType>();
  const wolsType = useWatch({ control, name: 'wols' });

  return (
    <>
      <FormRow title="WOLS Location" isRequired={false}>
        <div className="grow-0 flex-[48.5%]">
          <Controller
            name="wols"
            control={control}
            render={({ field: { value, ...field }, fieldState: { invalid, error } }) => (
              <TmdxSelect
                placeholder="Select Location"
                aria-label="Select Location"
                selectedKeys={value ? [value] : undefined}
                isInvalid={invalid}
                errorMessage={error?.message}
                disallowEmptySelection
                {...field}
              >
                {Object.keys(WOLSType).map((type) => (
                  <SelectItem key={type}>{type}</SelectItem>
                ))}
              </TmdxSelect>
            )}
          />
        </div>
      </FormRow>
      {wolsType === WOLSType.Other && (
        <FormRow title=" " isRequired={false}>
          <Controller
            name="wolsComment"
            control={control}
            render={({ field, fieldState: { invalid, error } }) => (
              <TmdxTextarea
                fullWidth
                maxLength={MAX_WOLS_COMMENT_LENGTH}
                disableAnimation
                minRows={3}
                placeholder="Description"
                isInvalid={invalid}
                errorMessage={error?.message}
                {...field}
              />
            )}
          />
        </FormRow>
      )}
    </>
  );
};
